import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';


import { getSessionOptions } from 'util/options';

import Stat from './Stat';

import { getCurrentMeet } from 'selectors';

import './StatsIndex.scss';


class StatsIndex extends Component {

  render() {
    const { meet } = this.props;

    return (
      <div className="stats-index">
        {
          _.map(getSessionOptions(), (session) => {
            const sessionLifters = _.filter(meet.lifters, {session: session.value});
            const sessionCount = _.size(sessionLifters);
            if(!sessionCount) {
              return null;
            }

            return (
              <div className="session-block" key={session.value}>
                {
                  _.map(_.sortBy(meet.platforms, 'name'), (platform) => {
                    const platformLifters = _.filter(sessionLifters, {platformId: platform._id});
                    const platformCount = _.size(platformLifters);
                    if(!platformCount) {
                      return null;
                    }

                    return (
                      <Stat key={platform._id} platformId={platform._id} session={session.value} title={`Session ${session.value} - Platform ${platform.name}`} />
                    );
                  })
                }
              </div>
            );
          })
        }

      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(StatsIndex);
